/* Farm Hero: same-page navigation and optional background video. */
if (!customElements.get('gg-farm-hero')) customElements.define('gg-farm-hero', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const signal = this.abort.signal;
    const targets = {farm_products:'.gg-box-products',status:'.gg-box-status',proofs:'.gg-box-proofs',farm_quote:'.gg-box-quote',complement:'.gg-box-complement',product_finder:'.wld-product-finder'};
    const resolve = link => {
      if (link.dataset.scrollTarget !== 'custom') {
        const selector = targets[link.dataset.scrollTarget];
        const section = selector && document.querySelector(selector);
        return section?.querySelector('[data-gg-section-anchor]') || section || null;
      }
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return null;
      try { return document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch { return null; }
    };
    this.links = [...this.querySelectorAll('[data-scroll-target]')];
    this.refresh = () => {
      this.links.forEach(link => {
        if (link.dataset.scrollTarget === 'custom') return;
        const target = resolve(link);
        link.hidden = !target;
        if (target) link.hash = (target.id ? target : target.closest('[id]')).id;
      });
    };
    this.refresh();
    document.addEventListener('shopify:section:load',this.refresh,{signal});
    document.addEventListener('shopify:section:unload',this.refresh,{signal});
    this.addEventListener('click', event => {
      const link = event.target.closest('[data-scroll-target]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const target = resolve(link);
      if (!target) return;
      event.preventDefault();
      const header = document.querySelector('nav[aria-label="Huvudnavigering"]') || document.querySelector('header-component') || document.querySelector('header');
      const rect = header?.getBoundingClientRect();
      const headerOffset = rect && rect.top <= 5 && rect.bottom > 0 ? Math.min(rect.bottom, 200) : 0;
      let scroller = target.parentElement;
      while (scroller && !(/auto|scroll/.test(getComputedStyle(scroller).overflowY) && scroller.scrollHeight > scroller.clientHeight)) scroller = scroller.parentElement;
      const scrollPosition = scroller ? scroller.scrollTop : window.scrollY;
      const scrollTop = scroller ? scroller.getBoundingClientRect().top : 0;
      const top = Math.max(0, scrollPosition + target.getBoundingClientRect().top - scrollTop - headerOffset - (Number(this.dataset.scrollOffset) || 0));
      (scroller || window).scrollTo({top,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      const hash = target.id ? '#' + target.id : link.hash;
      if (hash) history.pushState(null,'',hash);
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    },{signal});
    this.video = this.querySelector('video');
    this.toggle = this.querySelector('[data-video-toggle]');
    if (!this.video || !this.toggle) return;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.mobile = matchMedia('(max-width:749px)');
    this.manualPause = false;
    const paint = () => {
      this.toggle.textContent = this.video.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      this.toggle.setAttribute('aria-pressed',String(!this.video.paused));
    };
    this.syncVideo = () => {
      const hiddenMobile = this.mobile.matches && this.dataset.hideVideoMobile === 'true';
      this.toggle.hidden = hiddenMobile || this.dataset.showVideoToggle === 'false';
      this.video.hidden = hiddenMobile || this.reduced.matches;
      if (hiddenMobile || this.reduced.matches || this.manualPause || document.hidden) this.video.pause();
      else this.video.play().catch(paint);
    };
    this.video.addEventListener('play',paint,{signal});
    this.video.addEventListener('pause',paint,{signal});
    this.video.addEventListener('error',()=>{this.video.hidden=true;this.toggle.hidden=true;},{signal});
    this.toggle.addEventListener('click',()=>{
      this.manualPause = !this.video.paused;
      if (this.manualPause) this.video.pause(); else { this.video.hidden = false; this.video.play().catch(paint); }
    },{signal});
    this.reduced.addEventListener('change',this.syncVideo,{signal});
    this.mobile.addEventListener('change',this.syncVideo,{signal});
    document.addEventListener('visibilitychange',this.syncVideo,{signal});
    this.syncVideo();
    paint();
  }
  disconnectedCallback() { this.abort?.abort(); this.video?.pause(); }
});
